export default "__VITE_ASSET__DCIzamqp__"